// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__Gu6A2","hide":"styles_hide__QWw0C"};